import { LeadTableRow } from '@/types/Leads';
import { Box, Button } from '@palmetto/palmetto-components';
import { useCallback, useState } from 'react';

import { LeadManagementAcceptLeadModal } from './LeadManagementAcceptLeadModal';
import { LeadManagementRejectLeadModal } from './LeadManagementRejectLeadModal';

interface LeadManagementRowActionsCellProps {
  lead: LeadTableRow;
  location: string;
  onSuccess: (leadId: string) => void;
}

export function LeadManagementRowActionsCell({ lead, location, onSuccess }: LeadManagementRowActionsCellProps) {
  const leadId = lead.id;
  const [isAcceptOpen, setIsAcceptOpen] = useState(false);
  const [isRejectOpen, setIsRejectOpen] = useState(false);

  const handleOpenAccept = useCallback(() => setIsAcceptOpen(true), []);
  const handleCloseAccept = useCallback(() => setIsAcceptOpen(false), []);
  const handleOpenReject = useCallback(() => setIsRejectOpen(true), []);
  const handleCloseReject = useCallback(() => setIsRejectOpen(false), []);

  const handleAcceptConfirm = useCallback(() => {
    onSuccess(leadId);
    handleCloseAccept();
  }, [leadId, onSuccess, handleCloseAccept]);

  const handleRejectConfirm = useCallback(() => {
    onSuccess(leadId);
    handleCloseReject();
  }, [leadId, onSuccess, handleCloseReject]);

  return (
    <>
      <Box direction="row" childGap="xs">
        <Button
          variant="primary"
          tone="primary"
          size="sm"
          iconPrefix="check"
          type="button"
          onClick={handleOpenAccept}
        >
          Accept
        </Button>
        <Button
          variant="primary"
          tone="danger"
          size="sm"
          iconPrefix="remove"
          type="button"
          onClick={handleOpenReject}
        >
          Reject
        </Button>
      </Box>
      {isAcceptOpen && (
        <LeadManagementAcceptLeadModal
          isOpen
          onDismiss={handleCloseAccept}
          onConfirm={handleAcceptConfirm}
          leadId={leadId}
          location={location}
        />
      )}
      {isRejectOpen && (
        <LeadManagementRejectLeadModal
          isOpen
          leadId={leadId}
          onDismiss={handleCloseReject}
          onConfirm={handleRejectConfirm}
          location={location}
        />
      )}
    </>
  );
}
